import { BirdviewRequestAction } from '../DashboardBirdview.constants'

// The rule is the frontend's own until the backend ranks the actions: a
// request without an assignee asks to be assigned, everything else just opens.
export function getBirdviewRequestAction({ assignee, isInteractive, item }) {
  return isInteractive && !assignee && item.canEditAssignee
    ? BirdviewRequestAction.Assign
    : BirdviewRequestAction.Open
}

export function checkIsBirdviewAssignAction(action) {
  return action === BirdviewRequestAction.Assign
}
